import React, { useEffect } from 'react';
import { useState, Downgraded } from '@hookstate/core';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Divider,
    TextField,
    InputAdornment,
    Chip,
    Button,
    ListItem,
    Card,
    CardContent,
    IconButton,
    Tooltip,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
import StyledTableRowNew from '../../sharedcomponents/styledTable/styledTableRowNew';

import UserMediaCircuit from './userMediaCircuit';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import AddIcon from '@mui/icons-material/Add';
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import StatusCount from '../MediaCircuit/statusCount';
import UserCount from '../MediaCircuit/userCount';
import CachedIcon from '@mui/icons-material/Cached';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    listContent: {
        paddingBottom: theme.spacing(0),
        zIndex: 0,
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    stickyColumn: {
        position: 'sticky', left: 0, zIndex: 800, backgroundColor: 'white'
    },
    stickyHeaderColumn: {
        position: 'sticky',
        left: 0,
        zIndex: 900
    },
}));

const UserMediaCircuitList = (props) => {
    const classes = useStyles();
    const columnsData = useState(null);
    const rowsData = useState(null);
    const disableButton = useState(false);
    const [search, setSearch] = React.useState('');
    const filterRowsData = useState(null);
    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');

    const confirmDialog = useState({
        open: false,
        title: '',
        message: '',
        access: null,
        message: '',
        showUserMsg: false
    });
    useEffect(() => {
        // if (props.data && columnsData.get() == null && rowsData.get() == null) {
            const { columns, rows } = props.data;
            if (columns && columns.length > 0 && rows && rows.length > 0) {
                let newRows = setRowAllModulePermission(rows);
                rowsData.set(JSON.parse(JSON.stringify(newRows)));
                filterRowsData.set(JSON.parse(JSON.stringify(newRows)));
                let newColumns = setAllHeaderPermission(columns, newRows);
                columnsData.set(JSON.parse(JSON.stringify(newColumns)));
                search.length > 0 ? handleSearchChange(search) : null;
            }
        // }
    }, [props]);

    const handleSearchChange = (data) => {
        const value = data.trimStart();
        setSearch(value);
        if (value.length === 0) {
            resetCompletedCount(rowsData.attach(Downgraded).get());
            return;
        }
        const newFilterRowsData = [...rowsData.attach(Downgraded).get()];
        const lowerValue = value.toLowerCase();
        const modifyList = [];
        for (const row of newFilterRowsData) {
            for (const key of ['userName', 'role', 'tags', 'contentCircuitDateTime']) {
                const item = row[key];
                if (item && typeof item.label === 'string' && item.label.toLowerCase().includes(lowerValue)) {
                    modifyList.push(row);
                    break;
                }
            }
        }
        filterRowsData.set(modifyList);
        resetCompletedCount(modifyList)
    };
    const resetCompletedCount = (modifiedList) => {
        const { columns, rows } = props.data;
        if (columns && columns.length > 0 && rows && rows.length > 0) {
            let newRows = setRowAllModulePermission(modifiedList);
            filterRowsData.set(JSON.parse(JSON.stringify(newRows)));
            let newColumns = setAllHeaderPermission(columns, newRows);
            columnsData.set(JSON.parse(JSON.stringify(newColumns)));
        }
    }

    // const handleClick = (e) => {
    //     let userPermission = [];
    //     const eventInfo = Helper.getStorage('eventInfo');
    //     const userInfo = Helper.getStorage('userInfo');
    //     // e.preventDefault();
    //     if (filterRowsData.get() && filterRowsData.get().length > 0) {
    //         let newFilterRowsData = [...filterRowsData.attach(Downgraded).get()];
    //         let oldRowsData = [...rowsData.attach(Downgraded).get()];

    //         var newRowsData = newFilterRowsData.filter(function (p, idx) {
    //             return JSON.stringify(p) !== JSON.stringify(oldRowsData[idx]);
    //         });

    //         if (newRowsData && newRowsData.length > 0) {
    //             newRowsData.map((row) => {
    //                 let keys = Object.keys(row);
    //                 let obj = {};
    //                 let userName = row.userName;
    //                 let oldRecord;
    //                 if (userName && userName.userID) {
    //                     obj['userID'] = userName.userID;
    //                     oldRecord = oldRowsData.find(i => i.userName && i.userName.userID === userName.userID);
    //                 }
    //                 keys.forEach((key) => {
    //                     if (
    //                         key != 'allModules' &&
    //                         key != 'role' &&
    //                         key != 'userName' &&
    //                         key != 'tags'
    //                     ) {
    //                         //check if permission is changed for module then only add
    //                         if (!oldRecord || (oldRecord && JSON.stringify(oldRecord[key]) !== JSON.stringify(row[key]))) {
    //                             obj['eventID'] = eventInfo.eventID;
    //                             obj['activityTrackerID'] = row[key]['activityTrackerID'];
    //                             obj['status'] =
    //                                 row[key].permission == null
    //                                     ? 0
    //                                     : row[key].permission;
    //                             obj['createdBy'] = userInfo.userID;
    //                             userPermission.push(obj);
    //                             obj = {
    //                                 ...obj,
    //                                 eventID: 0,
    //                                 status: 0,
    //                                 createdBy: 0,
    //                             };
    //                         }
    //                     }
    //                 });
    //             });
    //         }
    //     }

    //     if (userPermission && userPermission.length > 0) {
    //         disableButton.set(true);
    //         ApiHelper.post(
    //             APIURLConstants.POST_USER_ACTIVITY_TRACKER_ACCESS,
    //             userPermission
    //         )
    //             .then((res) => {
    //                 if (res.data) {
    //                     sendCombineTrackerEmail(res.data);
    //                     // setSearch('');
    //                     // rowsData.set(null);
    //                     // columnsData.set(null);
    //                     // filterRowsData.set(null);
    //                     props.getAllData();
    //                     disableButton.set(false);
    //                 }
    //             })
    //             .catch((err) => {
    //                 if (err) {
    //                     console.log('err : ', err);
    //                     props.setSnackBarProps({
    //                         ...props.snackBarProps,
    //                         openSnack: true,
    //                         variant: 'error',
    //                         message: 'Error in Media Circuit updates',
    //                     });
    //                     disableButton.set(false);
    //                 }
    //             });
    //     }
    // };

    const sendCombineTrackerEmail = (result) => {
        let obj = {};
        obj.ID = 0;
        obj.IDs = result.toString();
        obj.eventID = eventInfo.eventID;
        obj.templateType = "Assign";
        obj.ModuleID = 24;

        ApiHelper.post(
            APIURLConstants.SEND_ACTIVITY_TRACKER_EMAIL,
            obj)
            .then((res) => {

            })
            .catch((err) => {
                if (err) {
                    console.log('err while sending combine activity tracker email : ', err);
                }
            });
    }

    const setAllHeaderPermission = (columns, rows) => {
        columns.map((column) => {
            if (
                column.id != 'userName' &&
                column.id != 'role' &&
                column.id != 'tags'
            ) {
                let totalRows = 0;
                let perm0 = 0;
                let perm1 = 0;
                let perm2 = 0;
                rows.forEach((row) => {
                    let keys = Object.keys(row);
                    keys.forEach((key) => {
                        if (key == column.id) {
                            if (row[key]['permission'] == 0) perm0++;
                            else if (row[key]['permission'] == 1) perm1++;
                            else if (row[key]['permission'] == 2) perm2++;
                            totalRows++;
                        }
                    });
                });
                column.inCompletedCount = totalRows - perm1;
                column.completedCount = perm1;
                if (totalRows > 0 && totalRows == perm0) {
                    column.permission = 0;
                } else if (totalRows > 0 && totalRows == perm1) {
                    column.permission = 1;
                } else if (totalRows > 0 && totalRows == perm2) {
                    column.permission = 2;
                } else {
                    column.permission = null;
                }
            }
        });
        return columns;
    };

    const setColumnHeaderPermission = (column, colIndex) => {
        column.permission = null;
        let newRowsData = [...filterRowsData.attach(Downgraded).get()];
        let totalRows = 0;
        let perm0 = 0;
        let perm1 = 0;
        let perm2 = 0;
        newRowsData.map((row) => {
            let keys = Object.keys(row);
            keys.map((key) => {
                if (key == column.id) {
                    if (row[key]['permission'] == 0) perm0++;
                    else if (row[key]['permission'] == 1) perm1++;
                    else if (row[key]['permission'] == 2) perm2++;
                    totalRows++;
                }
            });
        });
        if (totalRows > 0 && totalRows == perm0) {
            column.permission = 0;
        } else if (totalRows > 0 && totalRows == perm1) {
            column.permission = 1;
        }
        if (totalRows > 0 && totalRows == perm2) {
            column.permission = 2;
        }
        let newColumnsData = [...columnsData.attach(Downgraded).get()];
        if (column.permission == null) {
            const fIndex = newColumnsData.findIndex(
                (col) => col.id == 'allModules'
            );

            newColumnsData[fIndex].permission = null;
            const newColumn = { ...newColumnsData[fIndex] };
            columnsData[fIndex].set(newColumn);
        }
        columnsData[colIndex].set(column);
        setTimeout(() => {
            let newRowsData = [...filterRowsData.attach(Downgraded).get()];
            let newColumnsData = [...columnsData.attach(Downgraded).get()];
            let newColumns = setAllHeaderPermission(
                newColumnsData,
                newRowsData
            );
            columnsData.set(newColumns);
        }, 100);
    };

    const setUserPermission = (rowIndex, colIndex, column, access) => {
        let userPermission = [];
        let newRowsData = [...filterRowsData.attach(Downgraded).get()];
        // let newColumnsData = [...columnsData.attach(Downgraded).get()];

        let permission = access;

        let row = newRowsData[rowIndex];

        if (column.id == 'allModules') {
            const obj = {
                label: row.userName && row.userName.label
            }
            // showConfirmationDialog(obj, access, true)
            // if (row['allModules']['permission'] === 1) {
            //     permission = 0;
            // } else {
            //     permission = 1;
            // }
            let keys = Object.keys(row);
            keys.map((key) => {
                if (key != 'userName' && key != 'role' && key != 'tags') {
                    row[key]['permission'] = permission;
                }
            });
            filterRowsData[rowIndex].set(row);
            setColumnHeaderPermission(column, colIndex);
        } else if (
            column.id != 'userName' &&
            column.id != 'role' &&
            column.id != 'tags'
        ) {
            row[column.id]['permission'] = permission; //row[column.id]['permission'] === 1 ? 0 : 1;
            row['allModules']['permission'] = null;

            // logic to set all modules permission if all other modules are set to same permission for user
            let keys = Object.keys(row);
            let perm0 = 0;
            let perm1 = 0;
            let perm2 = 0;
            let moduleCount = 0;
            keys.map((key) => {
                if (
                    key != 'userName' &&
                    key != 'role' &&
                    key != 'allModules' &&
                    key != 'tags'
                ) {
                    if (row[key]['permission'] == 0) perm0++;
                    else if (row[key]['permission'] == 1) perm1++;
                    else if (row[key]['permission'] == 2) perm2++;
                    moduleCount++;
                }
            });
            if (moduleCount > 0 && moduleCount == perm0) {
                row['allModules']['permission'] = 0;
            } else if (moduleCount > 0 && moduleCount == perm1) {
                row['allModules']['permission'] = 1;
            } else if (moduleCount > 0 && moduleCount == perm2) {
                row['allModules']['permission'] = 2;
            }

            filterRowsData[rowIndex].set(JSON.parse(JSON.stringify(row)));
            // set column header permission as per all rows permission in the same column
            setColumnHeaderPermission(column, colIndex);
        }

        if (column.id !== 'allModules') {
            // handleClick();
        }

    };

    const setHeaderPermission = (newColumnsData) => {
        let perm0 = 0;
        let perm1 = 0;
        let perm2 = 0;
        let moduleCount = 0;
        let fIndex = newColumnsData.findIndex((col) => col.id == 'allModules');
        newColumnsData.map((col) => {
            if (
                col.id != 'userName' &&
                col.id != 'role' &&
                col.id != 'allModules' &&
                col.id != 'tags'
            ) {
                if (col['permission'] == 0) perm0++;
                else if (col['permission'] == 1) perm1++;
                else if (col['permission'] == 2) perm2++;
                moduleCount++;
            }
        });
        if (fIndex > -1) {
            if (moduleCount > 0 && moduleCount == perm0) {
                newColumnsData[fIndex].permission = 0;
            } else if (moduleCount > 0 && moduleCount == perm1) {
                newColumnsData[fIndex].permission = 1;
            }
            if (moduleCount > 0 && moduleCount == perm2) {
                newColumnsData[fIndex].permission = 2;
            }
        }
        return newColumnsData;
    };

    const setRowAllModulePermission = (newRowsData) => {

        newRowsData.map((row) => {
            // row['allModules']['permission'] = null;
            let perm0 = 0;
            let perm1 = 0;
            let perm2 = 0;
            let moduleCount = 0;
            let keys = Object.keys(row);
            keys.map((key) => {
                if (
                    key != 'userName' 
                ) {
                    if (row[key]['permission'] == 0) perm0++;
                    else if (row[key]['permission'] == 1) perm1++;
                    else if (row[key]['permission'] == 2) perm2++;
                    moduleCount++;
                }
            });
            if (moduleCount > 0 && moduleCount == perm0) {
                row['allModules']['permission'] = 0;
            } else if (moduleCount > 0 && moduleCount == perm1) {
                row['allModules']['permission'] = 1;
            } else if (moduleCount > 0 && moduleCount == perm2) {
                row['allModules']['permission'] = 2;
            }
        });
        return newRowsData;
    };
    const resetFilter = () => {
        const { columns, rows } = props.data;
        if (columns.length > 0 && rows.length > 0) {
            columnsData.set(JSON.parse(JSON.stringify(columns)));
            rowsData.set(JSON.parse(JSON.stringify(rows)));
            filterRowsData.set(JSON.parse(JSON.stringify(rows)));
        }
    };
    const onHeaderTotalClick = (colIndex, column, access) => {
        resetFilter()
    }
    const setUserHeadPermission = (colIndex, column, access) => {
        // console.log(colIndex, column, access);
        const { columns, rows } = props.data;
        
        let newRowsData = JSON.parse(JSON.stringify(rows));
        let newColumnsData = JSON.parse(JSON.stringify(columns));
        let permission = access;
        const moduleKey = column.id;
    
        // Update header permission
        newColumnsData[colIndex].permission = permission;
    
        // ✅ Only update rows where rejected > 0 for this module
        // const filteredRows = newRowsData.filter(
        //     (row) => row[moduleKey] && Number(row[moduleKey][permission]) > 0
        // );
        const filteredRows = newRowsData.filter((row) => {
            if (!row[moduleKey]) return false;
    
            if (permission === 'todo') {
                // Filter where todo > 0 OR rejected > 0
                return (
                    Number(row[moduleKey].todo) > 0 ||
                    Number(row[moduleKey].rejected) > 0
                );
            }
    
            // Default: filter where current permission count > 0
            return Number(row[moduleKey][permission]) > 0;
        });
    
        filteredRows.forEach((row) => {
            row[moduleKey].permission = permission;
        });
        // console.log("filteredRows",filteredRows);         
        // Final set
        columnsData.set(newColumnsData);
        filterRowsData.set(filteredRows); // you update the original list with selective changes
    };
     
    // const handleSubmit = (event) => {
    //     handleClick(event)
    //     confirmDialog.set({
    //         open: false,
    //         title: '',
    //         OkButtonText: 'Ok',
    //         access: null,
    //         message: '',
    //         showUserMsg: false
    //     });
    // }
    const onCancelClick = () => {
        const { columns, rows } = props.data;
        if (columns && columns.length > 0 && rows && rows.length > 0) {
            columnsData.set(JSON.parse(JSON.stringify(columns)));
            rowsData.set(JSON.parse(JSON.stringify(rows)));
            filterRowsData.set(JSON.parse(JSON.stringify(rows)));
        }
        confirmDialog.set({
            ...confirmDialog.get(),
            open: false,
            access: null,
        });
    } 
    const handleClearSearchChange = () => {
        setSearch('') 
        resetFilter();
    }
    return (
        // <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: '56px',
                    mb: 1.5,
                }}>
                <TextField
                    id="search"
                    size="small"
                    label={'Search'}
                    value={search}
                    onChange={(event) => { handleSearchChange(event.target.value)}}
                    autoComplete="off"
                    InputProps={{
                        endAdornment: (
                            <>
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={
                                            handleClearSearchChange
                                        }>
                                        <CloseOutlinedIcon />
                                    </IconButton>
                                </InputAdornment>
                            </>
                        ),
                    }}
                    sx={{
                        // m: 1,
                        maxWidth: { xs: '180px', md: '90%' },
                    }}
                /> 
            </Box>
            {columnsData.get() && filterRowsData.get() ? (
                <>
                    <Box
                        component="form"
                        sx={{
                            // p: 2,
                            width: '100%', overflow: 'hidden'
                        }}
                        autoComplete="off"
                        // onSubmit={handleClick}
                        >
                            <Paper sx={{ width: '100%', overflow: 'hidden',border: '1px solid #a6a7a7', borderRadius: '6px' }}>
                                <TableContainer sx={{ maxHeight: '70vh',  }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow size="small">
                                            {columnsData
                                                .attach(Downgraded)
                                                .get()
                                                .map((column, index) => (
                                                    <StyledTableCell
                                                        key={`column_${index}`}
                                                        align={column.align}
                                                        size="small"
                                                        className={column.id === 'userName' ? classes.stickyHeaderColumn : ''}
                                                    >
                                                            <Box
                                                                display="flex"
                                                                flexDirection="column"
                                                                alignItems="center" // Default for container
                                                            >
                                                            <Box alignSelf="center">
                                                                <Typography
                                                                    variant="h4"
                                                                    flexGrow={1}
                                                                    fontSize={14}
                                                                    fontWeight={500}
                                                                    sx={{ pb: 1 }}
                                                                    color="primary">
                                                                    {column.id === 'userName' ? (
                                                                        <>
                                                                            <Tooltip sx={{ m: 1 }} title="Reset Filter">
                                                                                <IconButton onClick={() => resetFilter()}>
                                                                                    <CachedIcon
                                                                                        color="primary"
                                                                                        fontSize="small"
                                                                                    />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </>) : (
                                                                        column.label
                                                                    )}
                                                                </Typography>
                                                            </Box>
                                                            {column.showPermission ? (
                                                                <> 
                                                                    <Box alignSelf="center">
                                                                        <UserMediaCircuit
                                                                            header={true}
                                                                            column={column}
                                                                            colIndex={index}
                                                                            setUserHeadPermission={
                                                                                setUserHeadPermission
                                                                            }
                                                                            onHeaderTotalClick={onHeaderTotalClick}
                                                                        />
                                                                    </Box>
                                                                </>
                                                            ) : null}
                                                        </Box>
                                                    </StyledTableCell>
                                                ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filterRowsData.get()
                                            ? filterRowsData
                                                .attach(Downgraded)
                                                .get()
                                                .map((row, rowIndex) => {
                                                    return (
                                                        <StyledTableRowNew
                                                            key={`row_${rowIndex}`}
                                                            hover
                                                            tabIndex={-1}>
                                                            {columnsData
                                                                .attach(
                                                                    Downgraded
                                                                )
                                                                .get()
                                                                .map(
                                                                    (
                                                                        column,
                                                                        colIndex
                                                                    ) => {
                                                                        const value =
                                                                            row[
                                                                            column
                                                                                .id
                                                                            ];
                                                                        return (
                                                                            <TableCell
                                                                                key={`row_column_${colIndex}`}
                                                                                align={
                                                                                    value.align
                                                                                }
                                                                                size="small"
                                                                                // className={column.id === 'userName' ? classes.stickyColumn : ''}
                                                                                >
                                                                                <Box
                                                                                    display="flex"
                                                                                    flexDirection="column"
                                                                                    alignItems={
                                                                                        value.align ==
                                                                                            'left'
                                                                                            ? 'flex-start'
                                                                                            : 'center'
                                                                                    }>
                                                                                    {value.showLabel ? (
                                                                                        <Typography
                                                                                            variant="h4"
                                                                                            flexGrow={
                                                                                                1
                                                                                            }
                                                                                            fontSize={
                                                                                                14
                                                                                            }
                                                                                            fontWeight={
                                                                                                400
                                                                                            }>
                                                                                            {column.id ===
                                                                                                'userName' ? (
                                                                                                value.label.search(
                                                                                                    'DELETED'
                                                                                                ) !==
                                                                                                    -1 ? (
                                                                                                    <>
                                                                                                        <span
                                                                                                            style={{
                                                                                                                color: 'red',
                                                                                                            }}>{`DELETED`}</span>{' '}
                                                                                                        <span>
                                                                                                            {value.label.replace(
                                                                                                                'DELETED',
                                                                                                                ''
                                                                                                            )}
                                                                                                        </span>
                                                                                                    </>
                                                                                                ) : (
                                                                                                    value.label.replace(
                                                                                                        'DELETED',
                                                                                                        ''
                                                                                                    )
                                                                                                )
                                                                                            ) : (
                                                                                                value.label
                                                                                            )}
                                                                                        </Typography>
                                                                                    ) : null}
                                                                                    {value.showPermission ? (
                                                                                        <UserMediaCircuit
                                                                                            value={
                                                                                                value
                                                                                            }
                                                                                            header={
                                                                                                false
                                                                                            }
                                                                                            column={
                                                                                                column
                                                                                            }
                                                                                            colIndex={
                                                                                                colIndex
                                                                                            }
                                                                                            row={
                                                                                                row
                                                                                            }
                                                                                            rowIndex={
                                                                                                rowIndex
                                                                                            }
                                                                                            setUserPermission={
                                                                                                setUserPermission
                                                                                            }
                                                                                        />
                                                                                    ) : null}
                                                                                    {value.showChips
                                                                                        ? value.label
                                                                                            ? value.label
                                                                                                .split(
                                                                                                    ', '
                                                                                                )
                                                                                                .map(
                                                                                                    (
                                                                                                        chipItem
                                                                                                    ) => {
                                                                                                        return (
                                                                                                            chipItem !==
                                                                                                            '' && (
                                                                                                                <Chip
                                                                                                                    key={
                                                                                                                        chipItem
                                                                                                                    }
                                                                                                                    label={
                                                                                                                        chipItem
                                                                                                                    }
                                                                                                                    sx={{
                                                                                                                        mr: '4px',
                                                                                                                        mb: '2px',
                                                                                                                        '& .MuiChip-label':
                                                                                                                        {
                                                                                                                            maxWidth:
                                                                                                                                '30ch',
                                                                                                                        },
                                                                                                                    }}
                                                                                                                />
                                                                                                            )
                                                                                                        );
                                                                                                    }
                                                                                                )
                                                                                            : null
                                                                                        : null}
                                                                                </Box>
                                                                            </TableCell>
                                                                        );
                                                                    }
                                                                )}
                                                        </StyledTableRowNew>
                                                    );
                                                })
                                            : null}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        <>
                            {/* <Divider component="div" sx={{ mt: 2 }} />
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                }}
                                item>
                                <ButtonContainer
                                    // handleClick={handleClick}
                                    handleCancel={handleCancel}
                                    buttonText={'Save'}
                                    cancelText={'Reset'}
                                    disableButton={disableButton.get()}
                                />
                            </Box> */}
                        </>
                    </Box>
                </>
            ) :
                (props.columns && props.columns.length === 0 && props.rows && props.rows.length === 0) ?
                    (
                        <ListItem className={classes.listItemContent}>
                            <Card
                                classes={{ root: classes.paperContent }}
                                sx={{ width: '100%' }}>
                                <CardContent
                                    sx={{ p: 2 }}
                                    className={classes.cardContent}>
                                    <Box className={classes.rowContent}>
                                        No data found
                                    </Box>
                                </CardContent>
                            </Card>
                        </ListItem>
                    ) : null}
            {/* {
                <ConfirmationDialog
                    open={confirmDialog.get().open}
                    messageFormat={messageFormat}
                    OkButtonText={confirmDialog.get().OkButtonText}
                    handleCnfClick={() =>
                        handleSubmit(confirmDialog)
                    }
                    showFormattedMsg
                    onCancelClick={() => {
                        onCancelClick()

                    }}></ConfirmationDialog>
            } */}
        </>
        // </Paper>
    );
};
export default UserMediaCircuitList;
